import authRoles from "core/auth/authRoles";
import Profile from "./Profile";

const ProfileConfig = {
  component: Profile,
  path: "/profile",
  exact: true,
  layout: {
    config: {
      header: {
        display: false,
      },
      sidebar: {
        display: false,
      },
      footer: {
        display: false,
      },
    },
  },
  protected: true,
  auth: authRoles.onlyGuest,
};

export default ProfileConfig;
